import { render } from "./OrderVerification.vue?vue&type=template&id=365b2204&scoped=true"
import script from "./OrderVerification.vue?vue&type=script&lang=js"
export * from "./OrderVerification.vue?vue&type=script&lang=js"

import "./OrderVerification.vue?vue&type=style&index=0&id=365b2204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365b2204"]])

export default __exports__